/*
 * Copyright (c) 2020.
 * Simon
 */

export default function isValueEmpty(value) {
    switch (value) {
        case undefined:
        case null:
        case "":
            return true;
        default:
            return false;
    }
}
